import { formatChatMessageTime, useTranslation } from "hhn-commons";
import { MessageStatusProps } from "../RecipientMessageStatus";
import {
  MessageDeliveryStatusBox,
  MessageSentIcon,
} from "./MessageStatus.style";

const MessageSentStatus = ({
  timestamp,
  showText = true,
}: MessageStatusProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });

  return (
    <MessageDeliveryStatusBox data-testid="message-sent-status">
      <MessageSentIcon />
      {showText && `${tNs("messageInfo.messageSentStatus")}, `}
      {timestamp && formatChatMessageTime(timestamp)}
    </MessageDeliveryStatusBox>
  );
};
export default MessageSentStatus;
